// extracted by mini-css-extract-plugin
export default {"container":"HeatFacts-module__container-UjzC7r","element":"HeatFacts-module__element-guKyeR","icon":"HeatFacts-module__icon-kURRRc"};